const apiUrl = "https://api.rextag.com/pipeline-statistics";

// const nowDate = new Date();
// const startDateChart = new Date();
// const startDateTable = new Date();
// const endDate = new Date();

// endDate.setDate(nowDate.getDate() - 14);
// startDateChart.setDate(endDate.getDate() - 30);
// startDateTable.setDate(endDate.getDate() - 8);
// const endDateStr = endDate.toJSON().split("T")[0];
// const startDateChartStr = startDateChart.toJSON().split("T")[0];
// const startDateTableStr = startDateTable.toJSON().split("T")[0];

const endDateStr = moment().subtract(14, 'days').format('YYYY-MM-DD');
const startDateChartStr = moment(endDateStr).subtract(30, 'days').format('YYYY-MM-DD');
const startDateTableStr = moment(endDateStr).subtract(8, 'days').format('YYYY-MM-DD');

let selectedTableDate, tableR, tableD, tableDates, tablesDataR, tablesDataD;

async function getPipelineData(rexcode, top, startDateStr, endDateStr) {
  if (!rexcode || !top) return;

  const apiParams =
    "?start_date=" +
    startDateStr +
    "&end_date=" +
    endDateStr +
    "&code=" +
    rexcode +
    "&top=" +
    top;

  const fetchUrl = apiUrl + apiParams;

  try {
    const response = await fetch(fetchUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const json = await response.json();
    // console.log(json);

    if (top == 4) processChartData(json);
    if (top == 10) processTableData(json);
  } catch (error) {
    console.error(error.message);
  }
}

function displayDate(date) {
  const options = {
    // weekday: 'long',
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const result = new Date(date).toLocaleDateString("en-US", options);

  return result;
}

function changeTablesDataHandler(e) {
  // console.log('changeTablesDataHandler');
  
  const shiftValue = Number(e.currentTarget.getAttribute("data-value")) || 0;
  const currentDateIndex = tableDates.indexOf(selectedTableDate);
  let newDateIndex = currentDateIndex + shiftValue;

  if(newDateIndex < 0) newDateIndex = tableDates.length - 1
  if(newDateIndex >= tableDates.length) newDateIndex = 0
  
  selectedTableDate = tableDates[newDateIndex];
  
  document.querySelector(".custom-pipeline-table-date").innerHTML =
    displayDate(selectedTableDate);
  
  updateDataTable(tableR, tablesDataR[selectedTableDate]);
  updateDataTable(tableD, tablesDataD[selectedTableDate]);
}

function createChartElement(point, index) {
  // console.log('createChartElement', point, index)
  
  if (!point) return;
  
  const chartId =
    "chart-" +
    index +
    "-" +
    point?.point.replaceAll(" ", "").toLowerCase() +
    "-" +
    point?.type;
  const parentElement =
    point?.type == "R"
      ? document.querySelector(
          ".custom-pipeline-charts .custom-pipeline-charts-r"
        )
      : document.querySelector(
          ".custom-pipeline-charts .custom-pipeline-charts-d"
        );

  const chartWrap = document.createElement("div");
  chartWrap.classList.add("custom-pipeline-chart-wrap");

  const chartHeader = document.createElement("div");
  chartHeader.classList.add("custom-pipeline-chart-header");

  const title = document.createElement("p");
  title.classList.add("custom-pipeline-chart-title");
  title.innerHTML = point?.point;

  const icon = document.createElement("div");
  icon.classList.add("custom-pipeline-chart-icon");
  if(point?.facility_type) icon.classList.add(point?.facility_type.toLowerCase());
  icon.innerHTML = "&nbsp;";

  const chart = document.createElement("canvas");
  chart.setAttribute("id", chartId);

  chartHeader.appendChild(title);
  chartHeader.appendChild(icon);
  chartWrap.appendChild(chartHeader);
  chartWrap.appendChild(chart);

  parentElement.appendChild(chartWrap);

  generateChart(point, chartId);
}

function pipelineValueFormat(value) {
  const result = Math.abs(value) / 1000

  return result.toFixed(2)
}

function generateChart(point, chartId) {
  if (!point) return;

  const chartLabels = point?.data.map((el) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(el.date).toLocaleDateString(
      "en-US",
      options
    );
    return formattedDate;
  });

  const chartValues = point?.data.map((el) => pipelineValueFormat(el.capacity));

  const chartColor = point?.type == "R" ? "88, 147, 43" : "198, 77, 77";
  const fullColor = "rgba(" + chartColor + ", 1)";
  const gradientColor = "rgba(" + chartColor + ", .75)";

  new Chart(document.getElementById(chartId), {
    type: "line",
    data: {
      labels: chartLabels,
      datasets: [
        {
          label: "MDth/d",
          data: chartValues,
          borderColor: fullColor,
          backgroundColor: fullColor,
          pointRadius: 2,
          borderWidth: 2,
          fill: {
            target: "start",
            above: gradientColor,
          },
        },
      ],
    },
    options: {
      scales: {
        x: {
          display: false, // Hide x-axis labels
        },
        y: {
          beginAtZero: true,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
      },
      interaction: {
        intersect: false,
        mode: "index",
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel + " MDth/d";
          },
        },
      },
    },
  });
}

function processChartData(jsonData) {
  if (!jsonData) return;

  const chartsDataR = jsonData.filter((el) => el.type == "R");
  const chartsDataD = jsonData.filter((el) => el.type == "D");

  chartsDataR.forEach((item, index) => {
    createChartElement(item, index);
  });

  chartsDataD.forEach((item, index) => {
    createChartElement(item, index);
  });
}

function processTableRows(data, type) {
  const result = {};
  data
    .filter((el) => el.type == type)
    .forEach((point) => {
      point.data.forEach((item) => {
        if (!result[item.date]) result[item.date] = [];
        const pointArray = [...result[item.date]];
        pointArray.push([point.point, pipelineValueFormat(item.capacity)]);
        result[item.date] = [...pointArray];
      });
    });
  console.log(result)
  return result;
}

function initDataTables() {
  //** init data tables
  tableR = new DataTable("#custom-pipeline-table-r", {
    paging: false,
    ordering: true,
    info: false,
    searching: false,
    columns: [
      { title: "Point", className: "text-left" },
      { title: "MDth/d", className: "text-right" },
    ],
    columnDefs: [
      { orderable: true, targets: [0, 1] },
      { width: '70%', targets: 0 }
    ],
    order: [[1, "desc"]]
  });

  tableD = new DataTable("#custom-pipeline-table-d", {
    paging: false,
    ordering: true,
    info: false,
    searching: false,
    columns: [
      { title: "Point", className: "text-left" },
      { title: "MDth/d", className: "text-right" },
    ],
    columnDefs: [
      { orderable: true, targets: [0, 1] },
      { width: '70%', targets: 0 }
    ],
    order: [[1, "desc"]]
  });
}

function updateDataTable(datatable, data) {
  // console.log("updateDataTable", datatable, data);
  datatable.clear().draw();
  data.forEach((el) => {
    // console.log(el);
    datatable.row.add(el);
  });
  datatable.draw();
}

function processTableData(jsonData) {
  if (!jsonData) return;

  tablesDataR = processTableRows(jsonData, "R");
  tablesDataD = processTableRows(jsonData, "D");
  // console.log("tablesDataR", tablesDataR);
  // console.log("tablesDataD", tablesDataD);

  tableDates = Object.keys(tablesDataR);
  // console.log("tableDates", tableDates);

  selectedTableDate = tableDates[0];
  // console.log("selected date data", tablesDataR[selectedTableDate]);

  document.querySelector(".custom-pipeline-table-date").innerHTML =
    displayDate(selectedTableDate);

  updateDataTable(tableR, tablesDataR[selectedTableDate]);
  updateDataTable(tableD, tablesDataD[selectedTableDate]);
}

(function () {
  const rexcode = document.getElementById("rexcode").getAttribute("data-value");

  initDataTables();
  getPipelineData(rexcode, 4, startDateChartStr, endDateStr);
  getPipelineData(rexcode, 10, startDateTableStr, endDateStr);

  document
    .querySelectorAll(".custom-pipeline-table-date-change")
    .forEach((el) => el.addEventListener("click", changeTablesDataHandler));
})();
